module.exports = __webpack_public_path__ + "static/media/logo2.c6c0a36b.png";